import { Link } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import PageHeader from '../../components/layout/PageHeader';
import Card from '../../components/ui/Card';
import Spinner from '../../components/ui/Spinner';
import EmptyState from '../../components/ui/EmptyState';
import { PendingEditBanner } from '../../components/candidates/StepEditRequest';
import { listPendingStepEditRequests } from '../../api/candidates';

const QUERY_KEY = ['pending-step-edit-requests'];

export default function PendingStepEdits() {
  const queryClient = useQueryClient();
  const query = useQuery({ queryKey: QUERY_KEY, queryFn: listPendingStepEditRequests });
  const rows = query.data || [];

  const refetch = () => queryClient.invalidateQueries({ queryKey: QUERY_KEY });

  return (
    <div>
      <PageHeader
        title="Pending Edit Approvals"
        description="Completed steps (and saved field sections) staff have requested a change to — nothing takes effect until approved here."
      />

      {query.isLoading ? (
        <div className="flex justify-center py-16">
          <Spinner />
        </div>
      ) : rows.length === 0 ? (
        <EmptyState title="Nothing pending" message="No edit requests are currently awaiting approval." />
      ) : (
        <div className="space-y-4">
          {rows.map((row) => (
            <Card key={row.step.pending_edit_request.id} className="!p-4">
              <div className="mb-3 flex items-center justify-between gap-2">
                <div>
                  <Link to={`/candidates/${row.candidate.id}`} className="text-sm font-semibold text-primary hover:underline">
                    {row.candidate.full_name}
                  </Link>
                  <span className="ml-2 text-xs text-gray-400">{row.candidate.reference_no}</span>
                  <p className="text-xs text-gray-500">{row.step.title}</p>
                </div>
              </div>
              <PendingEditBanner candidate={row.candidate} step={row.step} onResolved={refetch} />
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
